import { orderBy } from 'lodash'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import ArrowForwardSharpIcon from '@material-symbols/svg-300/sharp/arrow_forward.svg'
import Button from '../../components/basics/Button/Button'

import LearningItemTeaser from '../../components/LearningItemTeaser/LearningItemTeaser'
import Track from '../../components/Track/Track'
import useUserLearningItems from '../../state/queries/useUserLearningItems'
import useRoutes from '../../state/useRoutes'

import styles from './DashboardPage.module.scss'

export default React.memo(function DashboardPageContinueLearning({ userUuid }: { userUuid: string }) {
  const { t } = useTranslation()
  const routes = useRoutes()

  const { userLearningItems } = useUserLearningItems(userUuid)

  const items = useMemo(() => {
    return orderBy(
      userLearningItems.filter(
        (item) => item.kind === 'onDemandCourse' && item.onDemandCourse.booking && !item.learningProgress?.completedAt
      ),
      (item) => (item.learningProgress && item.learningProgress.lastAccessedAt?.toISOString()) || '',
      'desc'
    )
  }, [userLearningItems])

  return (
    <Track
      header={<h1>{t('dashboard.title continue learning')}</h1>}
      noItemsHint={
        <>
          <p>{t('dashboard.continue learning empty')}</p>
          <p>
            <Button component={Link} text to={routes.courses.url({})}>
              {t('dashboard.cta browse now')}
              <ArrowForwardSharpIcon />
            </Button>
          </p>
        </>
      }
      className={styles.DashboardPageContinueLearning}
    >
      {items.map((learningItem) => (
        <LearningItemTeaser extended key={learningItem.uuid} learningItem={learningItem} className={styles.teaser} />
      ))}
    </Track>
  )
})
